import showdown from 'showdown';
import { ParsedUrlQuery } from 'querystring';
import { escapeRegExp } from '@zola-helpers/client/dist/es/util/regex';

type ParsedFaqSearch = {
  term: string;
  skip: number;
};
export const parseFaqSearchQuery = (query: ParsedUrlQuery): ParsedFaqSearch => {
  let { term = '', skip = '0' } = query;
  // Always use the first query param value
  if (Array.isArray(term)) {
    [term] = term;
  }
  if (Array.isArray(skip)) {
    [skip] = skip;
  }
  return {
    skip: skip ? Number(skip) : 0,
    term,
  };
};

export const getPlainTextFromHtml = (html: string): string => {
  if (typeof window !== 'undefined') {
    // Get only the inner text
    const element = document.createElement('div');
    element.innerHTML = html;
    return element.innerText || '';
  }
  return '';
};

export const getArticleDescriptionSnippet = (plainText: string): string => {
  if (!plainText) return '';
  if (plainText.length < 200) {
    return plainText;
  }
  return `${plainText.slice(0, 200)}...`;
};

export const getBodySnippet = ({ body, query }: { body: string; query: string }) => {
  const converter = new showdown.Converter();
  const html = converter.makeHtml(body);

  const escapedQuery = escapeRegExp(query);

  // Can we strip the markdown instead so this renders server-side
  if (typeof window !== 'undefined') {
    // Get only the inner text
    const element = document.createElement('div');
    element.innerHTML = html;
    const textOnly = element.innerText || '';

    // (((\n)|(\\n)))(.*)(registry)(.*)((\n)|(\\n))
    const newlinesRegex = new RegExp(`((\n)|(\\n))`, 'g');
    const updated = textOnly.replace(newlinesRegex, ' ');

    // Match words surrounding search terms
    const queryWords = escapedQuery.split(' ').filter(w => w.length >= 3) || [];
    const queryRegex = queryWords.map(w => `(${w})`).join('|');
    const contextRegex = new RegExp(`\\b(\\w+\\W+){0,9}(${queryRegex})(\\W+\\w+){0,9}\\b`, 'i');
    const matches = contextRegex.exec(updated);

    // Fallback - display the first 100 characters
    const upToLastWordRegex = /.{0,100}( \w+)/;
    const fallback = upToLastWordRegex.exec(updated)?.[0] || updated.slice(0, 100);
    const finalString = matches ? matches[0] : fallback;

    // Inject ellipses
    const isStart = updated.slice(0, 5) === finalString.slice(0, 5);
    const withEllipses = `${isStart ? '' : '...'}${finalString}...`;

    // Highlight search terms
    const highlighted = queryWords.reduce((acc, w) => {
      const replaceRegex = new RegExp(w, 'gi');
      return acc.replace(replaceRegex, `<strong>${w}</strong>`);
    }, withEllipses);
    // eslint-disable-next-line react/no-danger
    return <span dangerouslySetInnerHTML={{ __html: highlighted }} />;
  }
  return null;
};

export const filterByWeddingBusiness = (query: object): object => {
  return {
    ...query,
    'fields.business.fields.name': 'Wedding',
    'fields.business.sys.contentType.sys.id': 'business',
  };
};
